import React from "react";
import classnames from "classnames";
import { getFieldPath } from "utils/form";
import { useFormikContext } from "formik";
import SlimCTA from "components/SlimCTA";
import WorkflowField from "../WorkflowField";
import get from "lodash/get";

const RecipientField = ({ name, focus, focusKey, setFocus }) => {
  const isFocused = focusKey === focus;
  const { values } = useFormikContext();
  const recipient = get(values, name);
  const containerProps = {
    className: classnames("flex flex-column ba br2 hairline-1 w-100 bg-white", {
      "bg-white--hover pointer": !isFocused
    })
  };

  let content;

  if (!recipient) {
    content = <SlimCTA header="No recipient" />;
  } else if (!isFocused) {
    containerProps.onClick = () => setFocus(focusKey);
    content = (
      <div className="pa3 flex flex-column w-100 o-50">
        <div className="f4 fw5">{recipient.roleName}</div>
      </div>
    );
  } else {
    const textTabs = get(recipient, "tabs.textTabs") || [];
    // TODO: if no tab nodes then show an error message and link to template show page in docusign
    const tabNodes = textTabs.map((tab, tabIx) => {
      const fieldKey = `tabs.textTabs[${tabIx}]`;
      const fieldName = getFieldPath(name, fieldKey);
      return (
        <li key={fieldKey}>
          <WorkflowField name={fieldName} />
        </li>
      );
    });

    const infoNodes = ["name", "email"].map((infoKey) => {
      const fieldName = getFieldPath(name, infoKey);
      return (
        <li key={infoKey}>
          <WorkflowField name={fieldName} />
        </li>
      );
    });

    content = (
      <div className="w-100 flex flex-column">
        <div className="pa3 flex flex-column w-100">
          <div className="f4 fw5">{recipient.roleName}</div>
        </div>
        <div className="bt hairline-1 w-100">
          <div className="pa3">
            <div className="w-100">
              <div className="fw6 f5 pb2">Info</div>
              <ul className="list ma0 pa0">{infoNodes}</ul>
            </div>
            <div className="w-100 pt3">
              <div className="fw6 f5 pb2">Tabs</div>
              <ul className="list ma0 pa0">{tabNodes}</ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return <div {...containerProps}>{content}</div>;
};

export default RecipientField;
